import React from "react";
import { Form } from "informed";
import { toast } from "react-toastify";
import { InputTypeText } from "../../../elements";
import Table from "../../../components/Table";
import Card from "../../../components/Card";
import ButtonAuth from "../../../components/ButtonAuth";
import { searchEnrollments, transferDocuments } from "../../../services/transfer_documents_service";

const makeColumns = (groupName, selectedId, onSelect) => [
  {
    Header: "",
    id: "radio",
    accessor: "id",
    width: 50,
    filterable: false,
    Cell: (row) => (
      <label className="input-radio-type">
        <input
          type="radio"
          name={groupName}
          value={row.original.id}
          checked={selectedId === row.original.id}
          onChange={() => onSelect(row.original.id)}
        />
        <span className="radiomark mt-0" />
      </label>
    ),
  },
  { Header: "Aluno", accessor: "name" },
  { Header: "Status", accessor: "status.name" },
  { Header: "Processo", accessor: "onboarding.name" },
  { Header: "Período", accessor: "onboarding.term_year" },
  { Header: "ID", accessor: "id", width: 80 },
];

class TransferirDocumentosForm extends React.Component {
  state = {
    enrollments: [],
    origemId: null,
    destinoId: null,
  };

  debounceTimeout = null;

  componentWillUnmount() {
    clearTimeout(this.debounceTimeout);
  }

  fetchMatriculas = (busca) => {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(async () => {
      if (!busca || !busca.trim()) {
        this.setState({ enrollments: [] });
        return;
      }
      try {
        const data = await searchEnrollments(busca);
        this.setState({ enrollments: Array.isArray(data) ? data : [] });
      } catch {
        toast.error("Erro ao buscar matrículas.");
      }
    }, 500);
  };

  handleGravar = async () => {
    const { origemId, destinoId } = this.state;

    if (!origemId || !destinoId) {
      toast.warn("Selecione origem e destino.");
      return;
    }

    try {
      await transferDocuments(origemId, destinoId);
      toast.success("Documentos transferidos com sucesso!");
      this.setState({ origemId: null, destinoId: null });
    } catch (error) {
      const msg = (error.response && error.response.data && error.response.data.message) || "Erro ao transferir documentos.";
      toast.error(msg);
    }
  };

  render() {
    const { enrollments, origemId, destinoId } = this.state;

    return (
      <section>
        <div className="list-base list-base-width">
          <h2>Transferir Documentos</h2>

          <Form onValueChange={({ aluno }) => this.fetchMatriculas(aluno)}>
            <div className="row">
              <InputTypeText field="aluno" label="Aluno" col="6" />
            </div>

            <Card title="Origem">
              <Table
                data={enrollments.filter((e) => e.id !== destinoId)}
                columns={makeColumns("origem", origemId, (id) => this.setState({ origemId: id }))}
                defaultPageSize={5}
                pageSize={5}
              />
            </Card>

            <Card title="Destino">
              <Table
                data={enrollments.filter((e) => e.id !== origemId)}
                columns={makeColumns("destino", destinoId, (id) => this.setState({ destinoId: id }))}
                defaultPageSize={5}
                pageSize={5}
              />

              <ButtonAuth
                type="button"
                onClick={this.handleGravar}
                disabled={!origemId || !destinoId}
              >
                Gravar
              </ButtonAuth>
            </Card>
          </Form>
        </div>
      </section>
    );
  }
}

export default TransferirDocumentosForm;
